export const RESOLVERS_IDS = {
  ALWAYS_VISIBLE: 'ALWAYS_VISIBLE',
  ALWAYS_ACTIVE: 'ALWAYS_ACTIVE',
  IS_TEXT_IN_SELECTION: 'IS_TEXT_IN_SELECTION',
  IS_TEXT_CONTAINS_BOLD: 'IS_TEXT_CONTAINS_BOLD',
  IS_TEXT_CONTAINS_ITALIC: 'IS_TEXT_CONTAINS_ITALIC',
  IS_TEXT_CONTAINS_UNDERLINE: 'IS_TEXT_CONTAINS_UNDERLINE',
  IS_TEXT_CONTAINS_QUOTE: 'IS_TEXT_CONTAINS_QUOTE',
  IS_TEXT_CONTAINS_CODE_BLOCK: 'IS_TEXT_CONTAINS_CODE_BLOCK',
  IS_TEXT_CONTAINS_ORDERED_LIST: 'IS_TEXT_CONTAINS_ORDERED_LIST',
  IS_TEXT_CONTAINS_UNORDERED_LIST: 'IS_TEXT_CONTAINS_UNORDERED_LIST',
  IS_TEXT_CONTAINS_SPOILER: 'IS_TEXT_CONTAINS_SPOILER',
  GET_ALIGNMENT_IN_SELECTION: 'GET_ALIGNMENT_IN_SELECTION',
  IS_TEXT_ALIGN_LEFT: 'IS_TEXT_ALIGNMENT_LEFT',
  IS_TEXT_ALIGN_CENTER: 'IS_TEXT_ALIGNMENT_CENTER',
  IS_TEXT_ALIGN_RIGHT: 'IS_TEXT_ALIGNMENT_RIGHT',
  IS_TEXT_ALIGN_JUSTIFY: 'IS_TEXT_ALIGNMENT_JUSTIFY',
  GET_HEADING_IN_SELECTION: 'GET_HEADING_IN_SELECTION',
  IS_HEADER_TWO_OR_THREE_SELECTED: 'IS_HEADER_TWO_OR_THREE_SELECTED',
  IS_TEXT_STYLES_MATCH_DOCUMENT_STYLES: 'IS_TEXT_STYLES_MATCH_DOCUMENT_STYLES',
  GET_LINE_SPACING_IN_SELECTION: 'GET_LINE_SPACING_IN_SELECTION',
  GET_LINE_SPACING_BEFORE_SELECTION: 'GET_LINE_SPACING_BEFORE_SELECTION',
  GET_LINE_SPACING_AFTER_SELECTION: 'GET_LINE_SPACING_AFTER_SELECTION',
  GET_FONT_SIZE_IN_SELECTION: 'GET_FONT_SIZE_IN_SELECTION',
  IS_TEXT_CONTAINS_LINK_OR_ANCHOR: 'IS_TEXT_CONTAINS_LINK_OR_ANCHOR',
  IS_TEXT_CONTAINS_LINK: 'IS_TEXT_CONTAINS_LINK',
  IS_TEXT_CONTAINS_ANCHOR: 'IS_TEXT_CONTAINS_ANCHOR',
  GET_TEXT_COLOR_IN_SELECTION: 'GET_TEXT_COLOR_IN_SELECTION',
  GET_HIGHLIGHT_COLOR_IN_SELECTION: 'GET_HIGHLIGHT_COLOR_IN_SELECTION',
  IS_UNDO_STACK_EMPTY: 'IS_UNDO_STACK_EMPTY',
  IS_REDO_STACK_EMPTY: 'IS_REDO_STACK_EMPTY',
  GET_URL_LINK_DATA: 'GET_URL_LINK_DATA',
  GET_ANCHOR_LINK_DATA: 'GET_ANCHOR_LINK_DATA',
  IS_NODE_SELECTED: 'IS_NODE_SELECTED',
  IS_NODE_OR_CAPTION_SELECTED: 'IS_NODE_OR_CAPTION_SELECTED',

  //plugins resolvers
  GET_NODE_IN_SELECTION: 'GET_NODE_IN_SELECTION',
  GET_NODE_ALIGNMENT: 'GET_NODE_ALIGNMENT',
  GET_NODE_SIZE: 'GET_NODE_SIZE',
  GET_NODE_TEXT_WRAP: 'GET_NODE_TEXT_WRAP',
  IS_NODE_CONTAINS_LINK_OR_ANCHOR: 'IS_NODE_CONTAINS_LINK_OR_ANCHOR',
  GET_NODE_LINK_DATA: 'GET_NODE_LINK_DATA',
};
